/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable arrow-body-style */

import React from 'react';
import { groupBy } from 'lodash';
import moment from 'moment-timezone';

import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';

import TableClientList from 'clientCommunications/components/Campaigns/TableClientList';

export class TableBlastSmsResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsMonth: '',
      detailsBucket: '',
    };
  }

  showDetails = (item) => {
    this.setState((current) => ({
      detailsMonth: { ...current.detailsMonth, [item]: !current.detailsMonth[item] },
    }));
  };
  showDetailsBucket = (bucket) => {
    this.setState((current) => ({
      detailsBucket: { ...current.detailsBucket, [bucket]: !current.detailsBucket[bucket] },
    }));
  };

  render() {
    const { t } = this.props;

    const data = this.props.blastSmsByMonth && this.props.blastSmsByMonth;

    return (
      <div className="automate-container" style={{ paddingTop: '0' }}>
        <table className="tbl-blastmsg-results">
          <tbody>
            {data &&
              data.map(([item, value]) => {
                let clientsForMonthSize = 0;
                if (value && Array.isArray(value)) {
                  clientsForMonthSize = value.reduce(
                    (totalClient, message) => totalClient + parseInt(message.unique_recipients_count, 10),
                    0,
                  );
                }
                const groupByBucketType = groupBy(value, 'bucket');
                const calcSmsSent = () => {
                  let sum = 0;
                  if (Array.isArray(value)) {
                    sum = value.reduce((sms, e) => sms + e.sms_count, 0);
                  }
                  return sum;
                };
                const calcBookings = () => {
                  let sum = 0;
                  if (Array.isArray(value)) {
                    sum = value.reduce((sms, e) => sms + e.appointments_count, 0);
                  }
                  return sum;
                };
                const calcRevenue = () => {
                  let sum = 0;
                  if (Array.isArray(value)) {
                    sum = value.reduce((sms, e) => sms + e.revenue, 0);
                  }
                  return sum.toFixed(2);
                };
                const calcSmsCost = () => {
                  let sum = 0;
                  if (Array.isArray(value)) {
                    sum = value.reduce((sms, e) => sms + e.cost, 0);
                  }
                  return sum.toFixed(2);
                };

                return (
                  <tr className="tbl-row" key={item}>
                    <td className="">
                      <table className={`tbl-inner-result ${!this.state.detailsMonth[item] ? '' : 'opened'}`}>
                        <tbody>
                          <tr>
                            <td colSpan="5">
                              <div className={`visible-content ${!this.state.detailsMonth[item] ? '' : 'opened'}`}>
                                <table className="tbl-single-row">
                                  <tbody>
                                    <tr className="big-font">
                                      <td className="date-width">
                                        <div onClick={() => this.showDetails(item)} role="button" tabIndex="0">
                                          <div className="yy-mm">
                                            <span>{item}</span>
                                            <span>
                                              {!this.state.detailsMonth[item]
                                                ? t('campaigns.tableRows.viewMsg')
                                                : t('campaigns.tableRows.hideMsg')}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="target-width">{t('campaigns.tableRows.allSentMsg')}</td>
                                      <td className="message-width">
                                        <span className="f-28">{clientsForMonthSize}</span>
                                        <span className="d-block">{t('campaigns.tableRows.clients')}</span>
                                      </td>
                                      <td className="sms-sent-width">
                                        <span className="f-28">{calcSmsSent()}</span>
                                      </td>
                                      <td className="booking-width">
                                        <span className="f-28">{calcBookings()}</span>
                                      </td>
                                      <td className="revenue-width">
                                        <span className="f-28">
                                          <CurrencySign />
                                          {calcRevenue()}
                                        </span>
                                      </td>
                                      <td className="sms-cost-width 1">
                                        <span className="f-28">
                                          <CurrencySign />
                                          {calcSmsCost()}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              {this.state.detailsMonth[item] &&
                                Object.entries(groupByBucketType).map(([bucket, valueBucket]) => {
                                  const calcClientsInBucket = () => {
                                    let unicClient = 0;
                                    if (Array.isArray(valueBucket)) {
                                      unicClient = valueBucket.reduce((sms, e) => sms + e.unique_recipients_count, 0);
                                    }
                                    return unicClient;
                                  };
                                  const calcSmsSentBucket = () => {
                                    let sum = 0;
                                    if (Array.isArray(valueBucket)) {
                                      sum = valueBucket.reduce((sms, e) => sms + e.sms_count, 0);
                                    }
                                    return sum;
                                  };
                                  const calcBookingsBucket = () => {
                                    let sum = 0;
                                    if (Array.isArray(valueBucket)) {
                                      sum = valueBucket.reduce((sms, e) => sms + e.appointments_count, 0);
                                    }
                                    return sum;
                                  };
                                  const calcRevenueBucket = () => {
                                    let sum = 0;
                                    if (Array.isArray(valueBucket)) {
                                      sum = valueBucket.reduce((sms, e) => sms + e.revenue, 0);
                                    }
                                    return sum.toFixed(2);
                                  };
                                  const calcSmsCostBucket = () => {
                                    let sum = 0;
                                    if (Array.isArray(valueBucket)) {
                                      sum = valueBucket.reduce((sms, e) => sms + e.cost, 0);
                                    }
                                    return sum.toFixed(2);
                                  };
                                  return (
                                    <div className="bucket-by-type" key={bucket}>
                                      <table className="tbl-single-row">
                                        <tbody>
                                          <tr className="big-font">
                                            <td className="date-width">
                                              <div
                                                onClick={() => this.showDetailsBucket(bucket)}
                                                role="button"
                                                tabIndex="0"
                                              >
                                                <div className="btn btn-link">
                                                  <span>
                                                    {!this.state.detailsBucket[bucket]
                                                      ? t('campaigns.tableRows.viewMsg')
                                                      : t('campaigns.tableRows.hideMsg')}
                                                  </span>
                                                </div>
                                              </div>
                                            </td>
                                            <td className="target-width">
                                              <span style={{ display: 'block' }}>
                                                {bucket === 'appointment' && t('campaigns.tableRows.appointment')}
                                                {bucket === 'canceled_last_month' &&
                                                  t('campaigns.tableRows.cancelledClients')}
                                                {bucket === 'all' && t('campaigns.tableRows.allClients')}
                                                {bucket === 'cancelations' && t('campaigns.tableRows.cancelledClients')}
                                                {bucket === 'invalid_patch_test' &&
                                                  t('campaigns.tableRows.patchTestClients')}
                                                {bucket === 'with_phones' && (
                                                  <div>{t('campaigns.tableRows.clientsWithPhone')}</div>
                                                )}
                                                {bucket === 'upcoming' && t('campaigns.tableRows.upcomingClients')}
                                                {bucket === 'first_time' && t('campaigns.tableRows.newClients')}
                                                {bucket === 'active' && t('campaigns.tableRows.regularClients')}
                                                {bucket === 'birthday' && t('campaigns.tableRows.birthdayClients')}
                                                {bucket === 'lost' && t('campaigns.tableRows.lapsedClients')}
                                              </span>
                                            </td>
                                            <td className="message-width">
                                              <span className="d-inline">
                                                {calcClientsInBucket()} {t('campaigns.tableRows.clients')}
                                              </span>
                                            </td>
                                            <td className="sms-sent-width">
                                              <span className="f-28">{calcSmsSentBucket()}</span>
                                            </td>
                                            <td className="booking-width">
                                              <span className="f-28">{calcBookingsBucket()}</span>
                                            </td>
                                            <td className="revenue-width">
                                              <span className="f-28">
                                                <CurrencySign />
                                                {calcRevenueBucket()}
                                              </span>
                                            </td>
                                            <td className="sms-cost-width 1">
                                              <span className="f-28">
                                                <CurrencySign />
                                                {calcSmsCostBucket()}
                                              </span>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      {this.state.detailsBucket[bucket] && (
                                        <div>
                                          {groupByBucketType[bucket].map((message) => {
                                            return (
                                              <div key={message.id}>
                                                <div
                                                  className={`bucket-message ${
                                                    message.isCollapsed !== false ? 'opened' : ''
                                                  }`}
                                                >
                                                  {message.isCollapsed ? (
                                                    <button
                                                      onClick={() => this.props.hideContent(message.id)}
                                                      className="btn btn-violet btn-sm"
                                                    >
                                                      {t('campaigns.tableRows.hideDetailsBtn')}
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="btn btn-violet btn-sm"
                                                      key={message.id}
                                                      onClick={() => this.props.showContent(message.id)}
                                                    >
                                                      {t('campaigns.tableRows.viewRecipientsBtn')}
                                                    </button>
                                                  )}
                                                  <span className="purple">
                                                    {t('campaigns.tableRows.sentOn')}
                                                    {S.space}
                                                    {/* TODO: date localisation */}
                                                    {moment(message.timestamp).format('D MMM')}
                                                    {S.space}
                                                    {t('campaigns.tableRows.at')}
                                                    {S.space}
                                                    {/* TODO: date localisation */}
                                                    {moment(message.timestamp).format('h:mma')} -{S.space}
                                                  </span>
                                                  {message.text}
                                                  {message.isCollapsed && (
                                                    <TableClientList
                                                      campaignId={message.id}
                                                      clients={message.clients}
                                                      wholeList // ={false}
                                                      sortFunction={this.props.sortFunction}
                                                    />
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    );
  }
}

const TableBlastSmsResultHoc = withTranslation()(TableBlastSmsResult);

export default TableBlastSmsResultHoc;
